// @flow
import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
import SaveIcon from "@material-ui/icons/Save";
import Fab from "@material-ui/core/Fab";
import { Select } from "app/components/Select";
import api from "utils/API";
import styles from "./PostHashtags.styles.js";

type Props = {
  value: any,
  slug: String
};

type State = {
  optionsList?: Array<Object> | null
};

class PostHashtags extends React.Component<Props, State> {
  unmounted = false;
  DEFAULT_DATA = {
    category: [{}],
    redirectTo: null
  };
  defaultData = this.DEFAULT_DATA;
  contentRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      success: false,
      data: this.DEFAULT_DATA,
      meta: {},
      gallery: { isOpen: false, items: [] },
      optionsList: null
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.hashtags !== this.props.hashtags) {
      this.updateList(this.props.hashtags);
    }
  }

  updateList = list => {
    const optionsList = !list
      ? null
      : list.map(hashtag => {
          return {
            label: hashtag.name || hashtag.label,
            value: hashtag.uid || hashtag.value
          };
        });

    this.setState({ optionsList });
  };

  handleButtonClick = () => {
    if (!this.state.loading) {
      this.send();
    }
  };

  send = () => {
    this.setLoading();

    const data = {
      hashtags: this.state.optionsList.map(hashtag => hashtag.value)
    };

    api
      .post(`/admin/posts/edit?type=post&id=${this.props.postId}`, data)
      .then(response => {
        this.setSuccess();
        console.log(response.status, response.data);
      })
      .catch(error => {
        this.setError();
        console.log(error.response.status);
      });
  };

  setSuccess = () => {
    this.setState({ loading: false, success: true });
  };

  setError = () => {
    this.setState({ loading: false, error: true });
  };

  setLoading = () => {
    this.setState({ loading: true, error: false, success: false });
  };

  handleSelectChange = (newValue: any, actionMeta: any) => {
    this.updateList(newValue);
    console.log(newValue, `action: ${actionMeta.action}`);
  };

  render() {
    const { classes } = this.props;
    // const classes = useStyles();
    const buttonClassname = clsx({
      [classes.buttonSuccess]: this.state.success,
      [classes.fab]: true
    });

    return (
      <Grid container>
        <Grid item xs={10} sm={11} md={11} className={classes.sendButtonWrapper}>
          <Select
            fullWidth
            isMulti
            fetchUrl="/admin/taxonomies/hashtag_match?f_count=10&f_q=:_text_:"
            options={this.state.optionsList}
            onChange={this.handleSelectChange}
            value={this.state.optionsList}
          />
        </Grid>
        <Grid item xs={2} sm={1} md={1}>
          <div className={classes.sendButtonWrapper}>
            <Fab
              aria-label="save"
              className={buttonClassname}
              onClick={this.handleButtonClick}
            >
              {this.state.success ? <CheckIcon /> : <SaveIcon />}
            </Fab>
            {this.state.loading && (
              <CircularProgress size={68} className={classes.fabProgress} />
            )}
          </div>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  metaTags: state.metaTags
});

const Component = connect(mapStateToProps)(withStyles(styles)(PostHashtags));
export { Component as PostHashtags };
export default Component;
